module.exports = "/assets/data/8914383f77bedc48e836bc4b7e9e7062-B9.data.json";